import { CircleCheck } from "lucide-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";


const ComplianceStatus = ( props ) => {
  const { compliance="Compliant" } = props;

  const complianceList = [
  {   
    id: 1,
    category: "Training",
    percentage: 100,
  },
    {   
    id: 2,
    category: "Policy Acknowledgments",
    percentage: 100,
  },
  {   
    id: 3,
    category: "Document Submission",
    percentage: 100,
  },
  
];
  
  	return (
      <div className="performance">
          <div className="space-y-2">
            <h4 className="text-[12px] font-semibold">
              Compliance Status
            </h4>
            {complianceList.map((item) => (
              <div key={item.id} className="mt-2">
                <div className="flex items-center justify-between p-2 rounded-xl bg-white card-content slate rounded-lg">
                  <p className="text-[11px] text-slate-800">{item.category}</p>
                  <span className="flex items-center gap-1 text-[11px] font-semibold text-green-600">{item.percentage}% {<CircleCheck size={12}/>}</span>
                </div>
              </div>
            ))}
            <div className="flex items-center justify-between p-2 rounded-xl bg-white card-content slate rounded-lg">
              <p className="text-[11px] text-slate-800">Code of Conduct</p>
              <span className={`flex items-center gap-1 text-[8px] font-semibold status-indicator ${compliance.toLowerCase().replace(/\s+/g, "-")}`}>{compliance}</span>
            </div>
          </div>
        </div>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ComplianceStatus);
